<!-- @format -->

<template>
	<pc-crud
		ref="crud"
		:height="tableHeight"
		:data="listData"
		:toolbars="listConfig.toolbars"
		:search-form="listConfig.searchForm"
		:pk-key="pkKey"
		:columns="listConfig.columns"
		:row-handle="listConfig.rowHandle"
		:pagination="pagination"
		:loading="loading"
		:selection-type="multiple ? 'checkbox' : 'radio'"
		@selection-change="handleSelectionChange"
		@action-event="handleAction"
		@sort-change="handleSortChange"
		@pagination-change="handlePaginationChange"
	/>
</template>
<script>
	// import { queryPageList, queryWithGrade, queryRoleScope } from '@/api/platform/org/role';
	import { subsystemList as findAllSubsystem, roleQueryPageList as queryPageList } from '@/api/position/index';
	import { ActionUtils } from '@/utils/action';
	import SelectionMixin from '@/p-components/pcp-selector-dialog/mixins/selection';
	// import { $utils } from '@/utils/publicUtils';
	import { PcCrud } from '@/components/pc-crud/index';
	// import FormUtils from '@/business/platform/form/utils/formUtil';

	export default {
		components: {
			PcCrud,
		},
		mixins: [SelectionMixin],
		props: {
			// 所有字段数据,(包含主主子表)
			formData: [Object, Array],
			value: [Object, Array],
			// 类型节点ID
			partyTypeId: {
				type: [String, Number],
				default: '',
			},
			// 用户组ID
			currentOrgId: {
				type: [String, Number],
				default: '',
			},
			script: String,
			// 是否启用范围
			isUseScope: {
				type: Boolean,
				default: false,
			},
			isAuth: {
				type: Boolean,
				default: false,
			},
			multiple: Boolean,
			height: {
				type: String,
				default: '400px',
			},
			// 主键  如果主键不是pk需要传主键
			pkKey: {
				type: String,
				default: 'id',
			},
			orgId: [String, Number],
		},
		data() {
			return {
				radio: '',
				loading: false,
				pagination: { limit: 10 },
				sorts: {},
				listData: [],
				listConfig: {
					searchForm: {
						selector: true,
						forms: [
							{ prop: 'name', label: '角色名称' },
							{
								prop: 'systemId',
								label: '子系统名称',
								fieldType: 'select',
								valueKey: 'id',
								labelKey: 'name',
								resultField: 'data',
								selectFetch: findAllSubsystem,
							},
						],
					},
					// 表格字段配置
					columns: [
						{ prop: 'name', label: '角色名称', slotName: 'trans' },
						{ prop: 'roleAlias', label: '角色别名' },
						{ prop: 'subSystemName', label: '子系统名称', slotName: 'trans' },
					],
				},
			};
		},
		computed: {
			tableHeight() {
				const h = this.height.substr(0, this.height.length - 2);
				return parseInt(h) - 10;
			},
		},
		created() {
			this.loadData();
		},
		beforeUnmount() {
			this.pagination = null;
			this.sorts = null;
			this.listData = null;
			this.listConfig = null;
		},
		methods: {
			// 加载数据
			loadData() {
				this.loading = true;
				if (this.isAuth) {
					// queryWithGrade(this.getSearcFormData())
					// 	.then((response) => {
					// 		if (!response.data.pageResult || $utils.isEmpty(response.data.pageResult)) {
					// 			response.data.pageResult = {
					// 				limit: 20,
					// 				page: 1,
					// 				totalCount: 0,
					// 				totalPages: 0,
					// 			};
					// 		}
					// 		this.loading = false;
					// 		ActionUtils.handleListData(this, response.data);
					// 		this.setSelectRow();
					// 	})
					// 	.catch(() => {
					// 		this.loading = false;
					// 	});
				} else if (this.isUseScope) {
					if (this.partyTypeId === 'script') {
						// const dynamicValue = FormUtils.getCalDynamicValue(this.script, this.formData);
						// dynamicValue
						// 	.then((response) => {
						// 		const data = JSON.parse(response);
						// 		ActionUtils.handleListData(this, data);
						// 		this.setSelectRow();
						// 		this.loading = false;
						// 	})
						// 	.catch(() => {
						// 		this.loading = false;
						// 	});
					} else {
						// queryRoleScope(this.getSearcFormData())
						// 	.then((response) => {
						// 		if (!response.data.pageResult || $utils.isEmpty(response.data.pageResult)) {
						// 			response.data.pageResult = {
						// 				limit: 20,
						// 				page: 1,
						// 				totalCount: 0,
						// 				totalPages: 0,
						// 			};
						// 		}
						// 		ActionUtils.handleListData(this, response.data);
						// 		this.setSelectRow();
						// 		this.loading = false;
						// 	})
						// 	.catch(() => {
						// 		this.loading = false;
						// 	});
					}
				} else {
					queryPageList(this.getSearcFormData())
						.then((response) => {
							// if (!response.data.pageResult || $utils.isEmpty(response.data.pageResult)) {
							// 	response.data.pageResult = {
							// 		limit: 20,
							// 		page: 1,
							// 		totalCount: 0,
							// 		totalPages: 0,
							// 	};
							// }
							this.loading = false;
							ActionUtils.handleListData(this, response);
							this.setSelectRow();
						})
						.catch(() => {
							this.loading = false;
						});
				}
			},
			// 获取格式化参数
			getSearcFormData() {
				const params = this.$refs['crud'] ? this.$refs['crud'].getSearcFormData() : {};
				if (this.isAuth) {
					const obj = {
						partyType: 'org',
						partyId: this.orgId,
					};
					Object.assign(params, obj);
				}
				if (this.isUseScope) {
					const obj = {};
					obj.type = this.partyTypeId;
					if (obj.type === '3') {
						obj.partyId = this.currentOrgId;
					}
					obj.type === 'script' ? (obj.script = this.script) : null;
					Object.assign(params, obj);
				}
				return ActionUtils.formatParams(params, this.pagination, this.sorts);
			},
			// 处理分页事件
			handlePaginationChange(page) {
				this.changePageCoreRecordData();
				ActionUtils.setPagination(this.pagination, page);
				this.loadData();
			},
			// 处理排序
			handleSortChange(sort) {
				ActionUtils.setSorts(this.sorts, sort);
				this.loadData();
			},
			// 查询
			search() {
				this.loadData();
			},
			// 重置查询
			resetSearch() {
				this.$refs['crud'] ? this.$refs['crud'].resetSearch() : null;
				ActionUtils.setFirstPagination(this.pagination);
				this.search();
			},
			// 处理按钮事件
			handleAction(command) {
				switch (command) {
					case 'search': // 查询
						ActionUtils.setFirstPagination(this.pagination);
						this.search();
						break;
					case 'resetSearch': // 重置查询
						this.resetSearch();
						break;
					default:
						break;
				}
			},
		},
	};
</script>
